export default __webpack_public_path__ + "static/1795-25fb081ba45ab9d27d92bfdcdf419fe8.gif";